<template>
  <v-app>
    <v-main>
      <v-container>
        <v-row
          justify="center">
          <v-col
            lg="5"
            class="my-12">
            <v-card
              flat>
              <v-card-title>
                <img
                  src="../assets/logo-dark.png"
                  width="32px">
              </v-card-title>
              <v-card-text class="pa-8">
                <SignIn
                  v-if="type"
                  @changeType="type = !type">
                </SignIn>
                <SignUp
                  v-else
                  @changeType="type = !type">
                </SignUp>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import SignIn from '@/components/auth/signIn'
import SignUp from '@/components/auth/signUp'

export default {
  components: {
    SignIn,
    SignUp
  },

  data: () => ({
    type: true,
    email: '',
    passwd: ''
  }),

  methods: {
    async signInWithGoogle () {
      const provider = new this.$firebase.auth.GoogleAuthProvider()
      this.$firebase.auth().languageCode = 'ko'
      await this.$firebase.auth().signInWithPopup(provider)
    },

    async signInEmail () {
      const r = await this.$firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.passwd)
      console.log('signInEmail', r)
    },

    async signOut () {
      const r = await this.$firebase.auth().signOut()
      console.log('signOut', r)
    }
  }
}
</script>

<style scoped>
.v-main {
  background-image: url('../assets/bg-pattern-light.svg');
  background-size: cover;
  background-position: center;
}

.v-card__title {
  background-color: #336699;
  border-color: #336699;
  padding-top: 24px;
  padding-bottom: 24px;
  color: #FFFFFF;
  font-weight: 400;
  justify-content: center;
}
</style>




// WEBPACK FOOTER //
// src/views/Login.vue